import {AxiosRequest, HttpUtils} from "../../../utils/HttpUtils";

export const FlowApi = {

    getFlowsByContext: async (context: string) => {
        try {
            const params = new Map<string, string>();
            params.set('context', context);
            const requestUrl = HttpUtils.addQueryString('/v1/workflow/flow/list', params);
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
};
